import Model from "../Model";

class Continenttops extends Model{

    buildUrl ({ param }) {
        return ['/continent', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Continenttops;